import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import React from 'react';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: 'Roboto'
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    fontSize: 8,
    fontWeight: 'bold'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center',
    fontSize: 7
  },
  totalRow: {
    flexDirection: 'row',
    marginTop: 20,
    justifyContent: 'flex-end',
    width: '100%'
  },
  totalLabel: {
    width: '5%',
    fontSize: 8,
    fontWeight: 'bold',
    padding: 5,
    textAlign: 'right'
  },
  totalValue: {
    width: '8%',
    fontSize: 8,
    fontWeight: 'bold',
    padding: 5,
    textAlign: 'left'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, children, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {children}
  </PDFText>
);

export const RefundRegisterReportPdf = ({ data }) => {
  console.log(data);
  let totalRecdCash = 0;

  // Function to format the date as needed (e.g., dd/mm/yyyy)
  function formatDate(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Format currency
  function formatCurrency(amount) {
    const num = parseFloat(amount) || 0;
    return num.toFixed(2);
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Refund Register Report">
          <Page size="A4" orientation="landscape" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 10 }}
              fixed
            />
            
            {/* Header Row */}
            <View style={styles.row}>
              <Text style={styles.columnHeader}>Sr No.</Text>
              <Text style={styles.columnHeader}>Refund Date</Text>
              <Text style={styles.columnHeader}>Refund No.</Text>
              <Text style={{ ...styles.columnHeader, width: '200px' }}>Patient Name</Text>
              <Text style={styles.columnHeader}>UHID No.</Text>
              <Text style={styles.columnHeader}>Adm No.</Text>
              <Text style={{ ...styles.columnHeader, width: '200px' }}>Doctor Name</Text>
              <Text style={styles.columnHeader}>Refund Type</Text>
              <Text style={styles.columnHeader}>Total Refund</Text>
              <Text style={styles.columnHeader}>CreatedBy</Text>
            </View>

            {/* Data Rows */}
            {data && data.map((item, index) => {
              // Parse amount as number and add to total
              const amount = parseFloat(item.amount) || 0;
              totalRecdCash += amount;

              return (
                <View 
                  key={index} 
                  style={{ 
                    ...styles.row, 
                    backgroundColor: COLORS[index % COLORS.length],
                    borderBottomWidth: 0.5,
                    borderBottomColor: '#ccc',
                    borderBottomStyle: 'solid'
                  }}
                >
                  <Text style={styles.columnContent}>{index + 1}</Text>
                  <Text style={styles.columnContent}>{formatDate(item.date)}</Text>
                  <Text style={styles.columnContent}>{item.doc_no}</Text>
                  <Text style={{ ...styles.columnContent, width: '200px' }}>{item.patientName}</Text>
                  <Text style={styles.columnContent}>{item.uhid}</Text>
                  <Text style={styles.columnContent}>{item.ipd_no}</Text>
                  <Text style={{ ...styles.columnContent, width: '200px' }}>{item.consultant?.doctor || '-'}</Text>
                  <Text style={styles.columnContent}>{item.payment_mode}</Text>
                  <Text style={styles.columnContent}>{formatCurrency(amount)}</Text>
                  <Text style={styles.columnContent}>{item.createdBy}</Text>
                </View>
              );
            })}

            {/* Total Row */}
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Total:</Text>
              <Text style={styles.totalValue}>{formatCurrency(totalRecdCash)}</Text>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default RefundRegisterReportPdf;